var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 373.8,
    height: 222.6,
    viewBox: "0 0 373.8 222.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        opacity: 0.5;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        fill: #6dbba5;\r\n      }\r\n\r\n      .cls-3 {\r\n        opacity: 0.4;\r\n      }\r\n\r\n      .cls-4 {\r\n        opacity: 0.7;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #501d93;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no-mail--social-media-no-mail"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    className: "cls-2",
    d: "M365.1,184.4l-26.9-.2a8.7,8.7,0,0,1-2.6,1.6H365C366.4,185.7,366.4,184.5,365.1,184.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    "data-name": "vector 2",
    className: "cls-2",
    d: "M61.3,183.1c-23.7,0-41.2.1-48.3.4-5,.2-5,2-.1,2.3H59.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_3",
    "data-name": "vector 3",
    className: "cls-2",
    d: "M279.9,185.8h2.8l-.3-2h-3.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector_4",
    "data-name": "vector 4",
    className: "cls-3",
    d: "M328.1,149.4c4.3,1.9,1.2,6.3,4.2,6.1s7-.4,7.4,2.7c1.5,10.6,2.2,27.5-8.4,26.2-5.9-.7,6.8,14.2-26.6,14.1a50.6,50.6,0,0,1-13.8-2.4,7.2,7.2,0,0,1-5.4-5.8,125.7,125.7,0,0,1-2.2-37.4c.2-2.2,1-3.5,3.1-4.2,8-2.9,30.6-4.1,41.7.7Zm-41.9,4.4c-.3,1.7-1.2,23.3,2.7,36.5,1.7,5.5,22.4,5.2,30.2,3.7,5.9-1.1,7-3.9,7.7-8.3,2.1-11.8,2-20.1,1.2-31.6-14,5-27.9,4.5-41.8-.3ZM331,173.5c-.6,7.1-1.4,7.8.5,7.7s3.9-1.3,4.4-4.2a58,58,0,0,0,1-13.8c-.3-5.1.4-4.1-4.7-4.3-2.1-.1-.3,2.6-1.2,14.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_5",
    "data-name": "vector 5",
    className: "cls-3",
    d: "M305,70.3c0,5.8-1.2,13.3,3.5,25.5,3.6,9.4,1.1,17.2-3.2,26.3-3.3,7.3.7,12.6-.6,13s-4.4-6.1-1.2-14.8c3.8-10.3,6-14.4.8-27.9C301.8,85.8,301.9,76.1,305,70.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_6",
    "data-name": "vector 6",
    className: "cls-3",
    d: "M291.4,97.4c11.2,9.7,4.7,17.8,2.8,26.8-2.6,11.9,7.4,17.6,6.2,18.9s-.8.2-1.2-.1c-7.1-5.8-9.7-13-7-22,1.8-6.2,4.8-11.8.9-19.2a13.5,13.5,0,0,1-1.7-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_7",
    "data-name": "vector 7",
    className: "cls-3",
    d: "M317.6,112c1.9,11.1,1.7,11-3.3,20.1-3.1,5.7-.2,9.5-.8,9.9s-1.6-.7-2-1.6c-3.8-8,4.2-11.6,4.5-23.6a7.7,7.7,0,0,1,1.6-4.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "laptop",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector_8",
    "data-name": "vector 8",
    className: "cls-2",
    d: "M265,139.9c0-.3,0-81.4-.4-88.4-.3-4.9-.8-4.7-36.2-4.5a16.9,16.9,0,0,1,10.7,12h16.8c.7,1,.2,2.8.3,4.3s2.8,1.2-16.5,1.4c-.1,1-.2,2-.4,3,15,0,16.9.3,16.8,1.1v77.9c0,2.4,0,1.6-37.2,1.8-74,.3-93.5.2-99,.1-1.9,0-1.9-.5-1.9-.9L117.3,71c0-2.9-.1-2.9,2.9-3,47.1-.4,61.7.4,66.7-.2H193c3.9-1,5.7-1.9,9.1-2.8l-118.5.9c-1.8,0-.9-.2-1.1-6.7-.1-1.5,33.1-.9,122.5-.3A16.9,16.9,0,0,1,215.8,47h-4.5C72.6,47.2,73,45.8,72.7,51.1c-.4,10.2-.8,60.7-.5,114.7.1,4.1.2,4.3,4.4,4.3,22.1,0,158.2-.1,185.7-1.4,3.4-.2,2.8.2,2.7-28.8ZM114.5,68c1.9,0,1,.4,1.1,7.3,0,1.9.1,1.2-22.2,1.6-5.5.1-3.6,1.8-4.1-8C89.3,67.5,87.9,68.4,114.5,68Zm0,18.1c-25.2.3-25.2,1.3-25.2-.4.1-8.3-.4-7.6,1.3-7.5,16.1,0,21.9-.6,24-.3s1.1.5,1,1.3C115.3,85.1,116.3,86.1,114.5,86.1ZM89.3,95.9c.1-7.6-.3-7.6,1-7.6,25.3.3,25.3-.9,25.3.5,0,6.8.6,6.9-1,7-26.8.9-25.3,1.4-25.3.1Zm-.1,8.9c.3-6.2-.5-6.9,1-6.9,25.5-.4,25.5-1.1,25.5.5-.1,6.9.6,7.3-1,7.2C87.9,105.4,89.1,107,89.2,104.8Zm1.2,2.7c25.4-.2,25.4-1.2,25.4,1-.2,41.2,1.4,41.4-1.2,41.4-25.6.1-25.5,1.1-25.5-1.3C89.4,107.5,88.4,107.5,90.4,107.5Zm-8.2,1.6c.6-43.7-.5-41.1,1.4-41s3.1-.4,4,.3-.1,64.4-.2,80.4c0,1.9-.8,1.1-4.9,1.3C80.9,150.3,81.6,153,82.2,109.1Zm154.5,49c-85.6.9-126.3-.1-154.3.8-1.8,0-.8-1.1-1.1-5.9-.1-2-10.8-1.2,148.7-1.7,24.9,0,23.7-.1,24.9-.1s.8.9,1.2,5.2C256.3,158.7,256.3,157.9,236.7,158.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_9",
    "data-name": "vector 9",
    className: "cls-2",
    d: "M288.6,204.6c-23.6-33.4-22.9-33.3-28-33.1-9.5.6-166.1,1.3-166.1,1.3-19.9.1-21.2,0-22.5,1.9-3,4-.2-.2-17.8,24.7-8.7,12.4-9.3,9.1,31.9,9.8,12.1.2,196.9-1.2,200.5-.9s3.9-1,2-3.7Zm-26.3-18.2c2.3-.1,2.6,3.8.1,3.8H246.6c-.9,0-2.6-2.7-2.2-3.5S244.5,186.5,262.3,186.4Zm-29-8.3c5.5-.1,16.7-.1,23-.3,1.3,0,1.5.2,2.9,2.4a1.8,1.8,0,0,1-1.5,2.8c-23.7,0-23.4.3-23.7-.6C232,177.7,231.8,178.2,233.3,178.1Zm-29.5.4c.4-.6,2.3-.2,3.4-.2l21.1-.2c1.3,0,1.4.3,2.3,2.5a1.8,1.8,0,0,1-1.7,2.5c-24.4,0-24.1.5-24.4-1.1S203.2,179.4,203.8,178.5Zm-23.5,0c20.7,0,20.5-.8,20.9,1.1s2,3.6-.3,3.6c-17.7-.4-23.5,1.3-23.8-.9C176.5,178.4,176.5,178.5,180.3,178.5Zm-25.4,3.8c.1-3.6.1-3.7,3.6-3.7,15.7-.3,15.6-.2,15.7.4,1,4.4,1,4.3-.3,4.3C154.8,183.5,154.8,184,154.9,182.3Zm-53.7.7c1.5-5.9-.6-4.3,27.9-4.4.9,0,1.2.2,1.2,1.2-.2,3.9-.2,3.9-4,3.9-25.8.1-25.5,1.1-25.1-.7Zm19.1,3.8c.9,0,1.2.3,1.2,1.2-.2,2.9-.2,2.9-3,2.9-30.4.2-29.1,1.1-28.7-.8C90.9,185.9,89.5,187.1,120.3,186.8Zm-41.5-5.4c1.3-2.3,1.4-2.4,2-2.4h17a1.8,1.8,0,0,1,1.8,2.3c-.8,2.6-.7,2.7-1.4,2.7l-17.9.2a1.8,1.8,0,0,1-1.5-2.8Zm-4.2,7.1c1.1-1.7.8-1.8,2-1.8,12.4.2,12.4-.2,11.8,1.5-1.1,3.5,0,3.1-12.2,3.1A1.9,1.9,0,0,1,74.6,188.5Zm36.7,7.2c-1.1,4.3.3,4.7-3,4.8l-37.9.3a1.9,1.9,0,0,1-1.6-2.8c2.4-3.8,2.3-3.9,3.2-3.8C110.3,195,112.1,192.7,111.3,195.7Zm38.4.8c-.2,6-.2,2.2-18.3,3.6-.8.1-.3.2-17.2.3-1.9,0-.7-.5-.4-4.9.1-1.9.5-1.4,11.2-1.4C153.6,193.9,149.7,192.9,149.7,196.5Zm.3-8.3c-.2,2.5-.1,2.6-2.6,2.6-25.4.1-24.3.7-24-1.1.6-4.1-.4-2.7,25-3C149.6,186.7,150.1,186.8,150,188.2Zm-1-4.7c-17,.2-17.4.8-17-1.3s-.5-2.7.4-3.4,2.2-.2,3.3-.2c17.8,0,17.2-.5,16.9,1.5s-.3,3.4-3.6,3.4Zm3.2,5.7c.2-2.5.1-2.5,2.5-2.5,63.8-.1,63.4-1.2,63.8.8s1.5,2.8-.4,2.8C147.2,190.7,151.9,191.7,152.2,189.2Zm22,10.5c-7.2-.1-3,0-21,.3-1.6,0-1-.5-1.1-5.2-.1-1.4-.1-.9,18.2-1,3.9,0,4.5-.4,4.6,1.1.1,3.9,1.2,4.9-.7,4.8Zm45.6-.2c-42.3,0-42.2,1.3-42.2-1.3s-.9-3.2-.2-4.1,2.7-.3,4-.4h37.5c1.7,0,1.7.2,2.7,3.5A1.9,1.9,0,0,1,219.8,199.5Zm1.7-10.4a1.8,1.8,0,0,1,1.6-2.6c18.9,0,18.1-.7,18.8,1.3a1.8,1.8,0,0,1-1.7,2.4c-14.7,0-17.7.6-18.7-1.1Zm4.9,10.5c-1.5,0-1.5-.3-2.5-4a1.8,1.8,0,0,1,1.7-2.3c28.3,0,27.8-.5,28.3.9C257.3,202,261.4,198.3,226.4,199.6Zm42.3-.4c-11.4.1-9,1.1-11.2-3.4a1.7,1.7,0,0,1,1.6-2.6c10.3,0,8.1-1.1,11.1,3.2A1.8,1.8,0,0,1,268.7,199.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_10",
    "data-name": "vector 10",
    className: "cls-2",
    d: "M159.8,73.2c.1,1.5-8.4,1.4-26,1.1-.8,0-2,.3-2-.8s1.3-.9,2-.9C159.3,72.2,159.7,71.9,159.8,73.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_11",
    "data-name": "vector 11",
    className: "cls-2",
    d: "M121,72.5c-.1-1.9,3.1-4.3,5.5-2.5s-.4,3.8,2.1,6.2c1,.9,1.7,1.7,1.1,2.3s-2.1-2.8-4.8-2.1S121,75.1,121,72.5Zm3.4,2.4a2,2,0,1,0,.2-3.9C122.2,70.8,121.8,74.6,124.4,74.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_12",
    "data-name": "vector 12",
    className: "cls-2",
    d: "M88.6,64.3a1.9,1.9,0,1,1-.1-3.8A1.9,1.9,0,0,1,88.6,64.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_13",
    "data-name": "vector 13",
    className: "cls-2",
    d: "M94.2,64.1c-2.7-.4-2.2-3.6.2-3.4S96.5,64,94.2,64.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_14",
    "data-name": "vector 14",
    className: "cls-2",
    d: "M91.9,134.3c0-3.8.7-2.7,4-2.8,1.3-.1,1.6.5,1.7,1.6.1,4.2.1,4.2-3.8,4.1C92.5,137.1,91.9,136.2,91.9,134.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_15",
    "data-name": "vector 15",
    className: "cls-2",
    d: "M91.7,116.1c0-3.6.4-2.5,4-2.8,1.3-.2,1.7.4,1.7,1.6-.1,4.6.6,4-3.9,4C91.7,118.9,91.7,118.9,91.7,116.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_16",
    "data-name": "vector 16",
    className: "cls-2",
    d: "M91.9,125.1c0-3.7.6-2.4,4-2.8,1.2-.1,1.7.3,1.7,1.5-.1,4.8.5,4-4,4.2C91.5,128,92,127,91.9,125.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_17",
    "data-name": "vector 17",
    className: "cls-2",
    d: "M99.3,124.9c-.1-1.4,3.7-1.3,12.3-.8,1.3.1,1.3,1.8-.2,1.8C108.2,126,99.3,126.4,99.3,124.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_18",
    "data-name": "vector 18",
    className: "cls-2",
    d: "M106.1,116.9c-3.4-.3-6.9.6-7-1s6.9-1,12.2-.8a.9.9,0,1,1,0,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_19",
    "data-name": "vector 19",
    className: "cls-2",
    d: "M106,135c-5.4,0-6.7.3-6.7-.9s6.4-1,12.2-.8c1.4,0,1.5,1.8,0,1.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector_20",
    "data-name": "vector 20",
    className: "cls-5",
    d: "M201.3,100.5c-2.3-1.3-1.9-2.1-3.8-.1a33.9,33.9,0,0,1-14.1,9.5c-13.6,4.4-19.8-3.3-22.1.3-11.7,17.6-17,24.1-19.1,27.4s-1.5,3.1-1.1,5.8.4,1.3,14.8-2.4c-2.3.6,77.3-19.6,77-20.7s-1-3-1.8-3.8S223.4,114,201.3,100.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_21",
    "data-name": "vector 21",
    className: "cls-5",
    d: "M127.9,90.6c13.2,8.9,18.7,11.7,30.6,16.7.9.4,1.4.5.9,1.5s-19.4,27.6-19.7,27.6S132.2,104.3,127.9,90.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_22",
    "data-name": "vector 22",
    className: "cls-5",
    d: "M221.9,81.4a19.4,19.4,0,0,1-9.1-2.1A106.2,106.2,0,0,1,201,96.6c-1.7,2-1.5-.2,20.1,11.7,10,5.5,9.6,4.9,9.9,4.7s-4-17-7.4-31.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_23",
    "data-name": "vector 23",
    className: "cls-5",
    d: "M204.5,67.1,127.7,87.2c.7.8,24.4,13.5,24.4,13.5,29.7,15,39.1,7.8,58.1-23.1A16.9,16.9,0,0,1,204.5,67.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_24",
    "data-name": "vector 24",
    className: "cls-2",
    d: "M237.9,63.7c0,20.8-31.1,21.1-31.8,1.1a15.9,15.9,0,1,1,31.8-1.1ZM221.8,49.9c-18.3.1-18.2,27.8.5,27.6a13.8,13.8,0,0,0-.5-27.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_26",
    "data-name": "vector 26",
    className: "cls-3",
    d: "M170.9,30.4c-1.5,3.8-5.5,3.3-6.2-.9s.8-29.9,5.2-23.7C172,8.7,172.8,25.8,170.9,30.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_27",
    "data-name": "vector 27",
    className: "cls-3",
    d: "M146.2,35.4c.3,2.6-2.3,3.3-3.9,2.1s-7.7-8.6-10.2-14.7c-.9-2.4.9-4.2,3.1-2.6C141.7,24.7,146.2,32.3,146.2,35.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_28",
    "data-name": "vector 28",
    className: "cls-3",
    d: "M204.4,17.8c-.6,3.5-7.3,21-12.3,17.1a2.2,2.2,0,0,1-.7-2.6C193.9,24.4,204.3,10.3,204.4,17.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.acb1214d34b37a3252ae1491789f8dd0.svg";
export { ForwardRef as ReactComponent };